import React, { useRef } from 'react'
import useInView from 'src/hooks/useInView'

type VariantKey = 'fade' | 'slideUp' | 'zoom'

const HIDDEN_STYLES: Record<VariantKey, React.CSSProperties> = {
  fade: { opacity: 0 },
  slideUp: { opacity: 0, transform: 'translate3d(0, 40px, 0)' },
  zoom: { opacity: 0, transform: 'scale(0.95)' }
}

const VISIBLE_STYLES: Record<VariantKey, React.CSSProperties> = {
  fade: { opacity: 1 },
  slideUp: { opacity: 1, transform: 'translate3d(0, 0, 0)' },
  zoom: { opacity: 1, transform: 'scale(1)' }
}

interface AnimatedSectionProps {
  children: React.ReactNode
  variant?: VariantKey
  duration?: number
  delay?: number
  ease?: [number, number, number, number]
  className?: string
}

function AnimatedSection({
  children,
  variant = 'fade',
  duration = 0.8,
  delay = 0,
  ease = [0.4, 0, 0.2, 1],
  className = ''
}: AnimatedSectionProps) {
  const ref = useRef<HTMLElement | null>(null)
  const visible = useInView(ref)

  const easeStr = `cubic-bezier(${ease.join(',')})`
  const transition = `opacity ${duration}s ${easeStr} ${delay}s, transform ${duration}s ${easeStr} ${delay}s`

  return (
    <section
      ref={ref}
      className={className}
      style={{
        ...(visible ? VISIBLE_STYLES[variant] : HIDDEN_STYLES[variant]),
        transition,
        willChange: visible ? undefined : 'opacity, transform'
      }}
    >
      {children}
    </section>
  )
}

export default AnimatedSection
